import { BEAMER_CHANNEL_ID } from 'gcs-common/constants/channelConstants';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { Sidebar, SidebarProvider } from 'gcs-common/design-system/ui/sidebar';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getHasFeatureFlag, getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import {
  getMediaFullscreenUrl,
  getUploadFileError,
  getVideoFullscreenId,
} from 'gcs-common/slices/uiState/uiStateSelectors';
import { setUploadFileError } from 'gcs-common/slices/uiState/uiStateSlice';
import { useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import ErrorPopUp from '../ErrorPopUp/ErrorPopUp';
import IdleTimeManager from '../IdleTimeManager/IdleTimeManager';
import LeftBar from '../LeftBar/LeftBar';
import MediaFullscreen from '../MediaFullscreen/MediaFullscreen';
import OpMaintenanceBanner from '../OpMaintenanceBanner/OpMaintenanceBanner';
import RightBar from '../RightBar/RightBar';
import VideoFullscreen from '../VideoFullscreen/VideoFullScreen';
import styles from './styles.module.scss';

/*
 This is the main workspace for agents/ craftsmen with channel list, main chat window and tool bar
 */

const ChatWorkspace = () => {
  const mediaFullscreenUrl = useSelector(getMediaFullscreenUrl);
  const videoFullscreenId = useSelector(getVideoFullscreenId);
  const isAgent = useSelector(getIsAgent);
  const uploadFileError = useSelector(getUploadFileError);
  const dispatch = useDispatch();
  const isOpMaintenanceEnabled = useSelector(getHasFeatureFlag(FEATURE_FLAGS.OP_MAINTENANCE));

  const selectedChannelId = useSelector(getSelectedChannelId);
  const hideRightBarForBeamer = selectedChannelId !== BEAMER_CHANNEL_ID;

  const location = useLocation();
  const { pathname } = location;
  const hideRightBarForTickets = !pathname.startsWith(CHAT_ROUTES.TICKETS);

  const onCloseErrorPopop = useCallback(() => {
    dispatch(setUploadFileError({ uploadFileError: '' }));
  }, [dispatch]);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className={styles.agentRoot}>
        <ErrorPopUp title="daten-fehler" errorMessage={uploadFileError} onClose={onCloseErrorPopop} />
        {isAgent && <IdleTimeManager />}
        {isOpMaintenanceEnabled && <OpMaintenanceBanner />}
        <SidebarProvider>
          <LeftBar />
          <div className={styles.mainChatArea}>
            <div className={styles.chatCol}>
              <Outlet />
            </div>
            {hideRightBarForTickets && hideRightBarForBeamer && (
              <Sidebar side="right">
                <RightBar />
              </Sidebar>
            )}
          </div>
        </SidebarProvider>
      </div>
      {mediaFullscreenUrl && <MediaFullscreen mediaFullscreenUrl={mediaFullscreenUrl} />}
      {videoFullscreenId && <VideoFullscreen videoId={videoFullscreenId} />}
    </DndProvider>
  );
};

export default ChatWorkspace;
